import React, {useState,useEffect} from "react";
import { FaBars, FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser,faHandsHelping, faUsers, faBriefcase, faFileAlt, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import url from "../../function/url";
import Cookies from "js-cookie";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
function UnemployedNavbar() {
    const ID = Cookies.get("log_id");
    const navigate = useNavigate();
    const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
      });
      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
      const [isprofileDropdown,setProfiledropdown] = useState(false);
    
      const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
      };
    
      const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
      };

      const toggleProfile = () =>{
        setProfiledropdown(!isprofileDropdown);
      };
      const [username,setUsername] = useState("");
      const [image,setImage] = useState("");
      function LoginDetails() {
        axios.get(`${url.path}/login_details/${ID}/`)
        .then((res) =>{
            if (res.data.status){
                setUsername(res.data.name);
                const img = res.data.image;
                var imag = null
                if (img) {
                imag = `${url.path}/${img}`;
                }
                setImage(imag);
            }
        })
        .catch((err) => {
            Toast.fire({
              icon:'error',
              title:err
            })
          });
      }
      useEffect(()=>{
          LoginDetails();
        },[])

        function Logout() {
          Cookies.remove('User');
          Cookies.remove('log_id');
          navigate("/");
        }
        function bothwork() {
          closeMobileMenu();
          Logout();
        }
    return(
        <div className="dashboard-container">
      
      <div className="topbar">
        <div className="topbar-logo">JOB MARKET</div>
        
      </div>

     
      <div className="dashboard-content">
        <div className="sidebar">
          <div className="sidebar-profile">
            {image ? (
              <img src={image} className="user-img" />
            ) : (<img src="user8.jpeg" alt="Profile" />)} 
            <p>{username}</p>
            <span>✅ Verified</span>
          </div>
          <nav>
            <ul>
              <li className={`dropdown ${isprofileDropdown ? 'open' : ''}`}>
                <NavLink to="#" onClick={(e) =>{e.preventDefault(); toggleProfile();}} className="dropdown-toggles">
                  <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                  {isprofileDropdown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isprofileDropdown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="">View</NavLink>
                    </li>
                    <li>
                      <NavLink to="">Add</NavLink>
                    </li>
                  </ul>
                )}
              </li>
             

              <li>
                <NavLink to="">
                  <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job 
                </NavLink>
              </li>
              <li>
                <NavLink to="/unemployedsuggestion" className="flex items-center">
                  <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                  <span className="whitespace-nowrap">Suggestion and Counseling</span>
                </NavLink>
              </li>
              <li>
                <a onClick={Logout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="icon" />Logout
                  </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mobile-header">
          <FaBars className="menu-icon" onClick={toggleMobileMenu} />
        </div>

        {isMobileMenuOpen && (
          <div className="sidebar mobile-sidebar">
            <button className="close-menu-btn" onClick={closeMobileMenu}>
              <FaTimes className="close-icon" />
            </button>
            <nav>
              <ul>
                <li>
                <button className="dropdown-toggles" onClick={toggleProfile}>
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isprofileDropdown && (
                    <ul className="dropdown-menus">
                        <li>
                          <NavLink to="" onClick={closeMobileMenu}>View</NavLink>
                        </li>
                          <li>
                            <NavLink to="" onClick={closeMobileMenu}>Add</NavLink>
                          </li> 
                    </ul>
                  )}
                </li>
                
                
                <li>
                  <NavLink to="" onClick={closeMobileMenu}>
                    <FontAwesomeIcon icon={faFileAlt} className="icon" /> Job 
                  </NavLink>
                </li>
                <li>
                <NavLink to="/unemployedsuggestion" className="flex items-center">
                  <FontAwesomeIcon icon={faHandsHelping} className="icon" />
                  <span className="whitespace-nowrap">Suggestion and Counseling</span>
                </NavLink>
              </li>
                <li>
                  <NavLink to="/" onClick={bothwork}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" /> Logout
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </div>
    );
}
export default UnemployedNavbar;